module.exports = __webpack_public_path__ + "img/card1Img.c9a055c3.png";